import { jsx as _jsx } from "react/jsx-runtime";
import Select from '../../../../../../components/Select';
import t from '../../../../../../lib/translate';
var ChannelSelector = function (_a) {
    var setChannel = _a.setChannel, channels = _a.channels;
    return (_jsx(Select, { label: t('templates.create.channel'), defaultValue: channels[0], options: channels === null || channels === void 0 ? void 0 : channels.map(function (channel) { return ({
            value: channel.value,
            label: channel.label
        }); }), onChange: function (channel) {
            setChannel(channel.value);
        } }));
};
export default ChannelSelector;
